<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <el-form-item :label="$locale('setting.cinema.trailer.use')" prop="useTrailer" >
          <el-select v-model="detailObj.useTrailer">
            <el-option :value="true" :label="$locale('global.yes')" />
            <el-option :value="false" :label="$locale('global.no')" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="4">
        <el-form-item  prop="trailerWaitTime" >
          <span slot="label" class="makeInline">{{ $locale('setting.cinema.trailer.waitTime') }}</span>
          <el-input 
            placeholder="60" 
            v-model="detailObj.trailerWaitTime"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div v-for="(item,idx) in trailerList" v-bind:key="idx">
      <TrailerForm v-bind:formObj="item" :ref="'trailer'+idx" :total="total" :count="idx"
      @add="handleadd" @del="handledel" />
    </div>
  </div>
</template>
<style scoped>
.makeInline {
  white-space: nowrap;
}
</style>
<script>
import TrailerForm from '@/components/Cinema/TrailerForm'

export default {
  name: "TrailSetting",
  components: {
    TrailerForm,
  },

  props: {
    detailObj: {
      type: Object,
      default: {},
    }
  },

  data() {
    return {
      trailerList: this.detailObj.trailers, 
      total: 1,
    }
  },

  methods: {
    handleadd() {
      // add a component
      let item = {
        type: 1,
        link: '',
        order: 1+this.total,
        displayTime: 60,
     }
      this.total++
      this.trailerList.push(item)
    },
    handledel(idx) {
      // del a component
      this.trailerList.splice(idx, 1)
      this.total-- 
    },

    returnData() {
      let list = []
      let that = this
      this.trailerList.map((item,i) => {
        let data = that.$refs["trailer"+i][0].getData() 
        list.push(data)
      })
      return list 
    },

    setTrailers(trailers) {
      this.total = trailers.length
      this.count = 0
      this.trailerList = []
      
      this.trailerList = trailers
    }
  }
}
</script>
